window.FazendaRP = window.FazendaRP || {};

window.FazendaRP.renderNav = function (container) {
    const menuItems = [
        { id: 'dashboard', label: 'Visão Geral', icon: 'fas fa-chart-pie', active: true },
        { id: 'financeiro', label: 'Financeiro', icon: 'fas fa-wallet' },
        { id: 'relatorios', label: 'Relatórios', icon: 'fas fa-file-invoice' }, // Moved/New

        { id: 'operacional', label: 'Operacional', icon: 'fas fa-tasks' },
        { id: 'clima', label: 'Clima', icon: 'fas fa-cloud-sun' },
        { id: 'suprimentos', label: 'Suprimentos', icon: 'fas fa-boxes-stacked' },
        { id: 'maquinas', label: 'Máquinas', icon: 'fas fa-tractor' },
        { id: 'safra', label: 'Safra & Colheita', icon: 'fas fa-seedling' },
        { id: 'ir', label: 'Fiscal / IR', icon: 'fas fa-balance-scale' },
        { id: 'whatsapp', label: 'Inbox / Zap', icon: 'fab fa-whatsapp' },
        { id: 'auditoria', label: 'Auditoria', icon: 'fas fa-clipboard-list' },
        { id: 'sistema', label: 'Sistema', icon: 'fas fa-cog' }
    ];

    const navHtml = menuItems.map(item => `
        <li class="nav-item ${item.active ? 'active' : ''}" data-target="${item.id}">
            <i class="${item.icon}"></i>
            <span>${item.label}</span>
        </li>
    `).join('');

    container.innerHTML = `
        <div class="app-nav">
            <ul class="nav-list">
                ${navHtml}
            </ul>
        </div>
    `;

    // Configurar Navegação
    const items = container.querySelectorAll('.nav-item');
    items.forEach(item => {
        item.addEventListener('click', () => {
            // Visual update
            items.forEach(i => i.classList.remove('active'));
            item.classList.add('active');

            // Router Call
            const pageId = item.dataset.target;
            if (window.FazendaRP.loadPage) {
                window.FazendaRP.loadPage(pageId);
            }
        });
    });

    // Carregar página inicial
    if (window.FazendaRP.loadPage) {
        window.FazendaRP.loadPage('dashboard');
    }
};
